'use client';
import { useRouter } from 'next/navigation';
import { setRouter } from '../../lib/navigation';

export function RouterProvider() {
  const router = useRouter();
  setRouter(router);
  return null;
}
